import { styled } from '@mui/material';

export const Image = styled('img')({
	width: '100%',
	height: 'auto',
});
